<template>
  <el-dialog
    title="随机题目"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="dialogClose"
    custom-class="custom_dialog"
    top="20px"
  >
    <div
      style="overflow-y: auto; padding: 0px 30px 0px 10px"
      :style="formBodyStyle"
    >
      <el-table
        ref="multipleTable"
        :data="questionGroupList"
        border
        style="width: 100%; height: 247px"
        @selection-change="handleSelectionChange"
        @cell-mouse-leave="leaveCall"
        @row-click="selectRowChange"
        max-height="248"
        v-loading="tableLoading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column label="题库">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="questionManager(scope.row.Id)"
            >
              {{ scope.row.Name }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140"
          align="center"
          key="CreationTime"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.CreationTime | dateformat('YYYY.MM.DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <span style="margin: 0px 20px">共 {{ listTotalCount }} 条</span>
        <el-link
          type="primary"
          @click="nextPage()"
          v-show="questionGroupList.length < listTotalCount"
        >
          加载更多…
        </el-link>
        <el-link
          type="info"
          v-show="questionGroupList.length >= listTotalCount"
          :underline="false"
        >
          已全部加载
        </el-link>
      </div>
      <div
        style="
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
        "
      >
        <div>已选题库：</div>
        <div
          v-for="(item, index) in elementItem.RandomQuestionGroups"
          :key="index"
          style="margin: 0px 10px; border-bottom: 1px solid #404040"
        >
          {{ item.Name }}
        </div>
      </div>
      <div>
        <div style="margin: 10px 0px 0px 0px">
          <b>单选题</b> 随机抽取
          <el-input-number
            v-model="elementItem.RandomCondition.Single.QuestionNum"
            :min="0"
            :controls="false"
            size="mini"
            @blur="blurSingleNum"
          ></el-input-number>
          个题目，每题
          <el-input-number
            v-model="elementItem.RandomCondition.Single.QuestionScore"
            :precision="2"
            :min="0"
            :controls="false"
            size="mini"
          ></el-input-number>
          分
        </div>
        <div style="margin: 10px 0px 0px 0px">
          <b>多选题</b> 随机抽取
          <el-input-number
            v-model="elementItem.RandomCondition.Multiple.QuestionNum"
            :min="0"
            :controls="false"
            size="mini"
            @blur="blurMultipleNum"
          ></el-input-number>
          个题目，每题
          <el-input-number
            v-model="elementItem.RandomCondition.Multiple.QuestionScore"
            :precision="2"
            :min="0"
            :controls="false"
            size="mini"
          ></el-input-number>
          分
        </div>
        <div style="margin: 10px 0px 0px 0px">
          <b>判断题</b> 随机抽取
          <el-input-number
            v-model="elementItem.RandomCondition.TrueOrFalse.QuestionNum"
            :min="0"
            :controls="false"
            size="mini"
            @blur="blurTrueOrFalseNum"
          ></el-input-number>
          个题目，每题
          <el-input-number
            v-model="elementItem.RandomCondition.TrueOrFalse.QuestionScore"
            :precision="2"
            :min="0"
            :controls="false"
            size="mini"
          ></el-input-number>
          分
        </div>
        <div style="margin: 10px 0px 0px 0px">
          <b>填空题</b> 随机抽取
          <el-input-number
            v-model="elementItem.RandomCondition.Blank.QuestionNum"
            :min="0"
            :controls="false"
            size="mini"
            @blur="blurBlankNum"
          ></el-input-number>
          个题目，每题
          <el-input-number
            v-model="elementItem.RandomCondition.Blank.QuestionScore"
            :precision="2"
            :min="0"
            :controls="false"
            size="mini"
          ></el-input-number>
          分
        </div>
        <div style="margin: 10px 0px 0px 0px">
          <b>问答题</b> 随机抽取
          <el-input-number
            v-model="elementItem.RandomCondition.QA.QuestionNum"
            :min="0"
            :controls="false"
            size="mini"
            @blur="blurQANum"
          ></el-input-number>
          个题目，每题
          <el-input-number
            v-model="elementItem.RandomCondition.QA.QuestionScore"
            :precision="2"
            :min="0"
            :controls="false"
            size="mini"
          ></el-input-number>
          分
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="editElementRandomQuestion()">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import questionGroupApi from '../../api/wj/questionGroup.js'
export default {
  name: 'EditElementRandomQuestion',
  components: {
  },
  data () {
    return {
      dialogFormVisible: false,
      formBodyStyle: { maxHeight: (window.innerHeight - 250) + 'px' },
      elementItem: {
        RandomCondition: {
          QuestionGroupIds: [],
          Single: { QuestionNum: 0, QuestionScore: 0 },
          Multiple: { QuestionNum: 0, QuestionScore: 0 },
          TrueOrFalse: { QuestionNum: 0, QuestionScore: 0 },
          Blank: { QuestionNum: 0, QuestionScore: 0 },
          QA: { QuestionNum: 0, QuestionScore: 0 }
        },
        RandomQuestionGroups: []
      },
      itemIndex: 0,
      action: 'add',
      questionGroupList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingId: null,
        companyId: null,
        maxResultCount: 10,
        skipCount: 0,
        Sorting: 'CreationTime desc'
      },
      pagination_layout: 'prev, pager, next',
      selectRows: [],
      tableLoading: false
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getQuestionGroups: function () {
      const _this = this
      _this.tableLoading = true
      questionGroupApi.getQuestionGroups(_this.listQuery).then(data => {
        data.Items.forEach(item => {
          _this.questionGroupList.push(item)
        })
        _this.listTotalCount = data.TotalCount
        _this.$nextTick(() => {
          _this.questionGroupList.forEach(function (row, index) {
            _this.elementItem.RandomCondition.QuestionGroupIds.forEach(function (selectItem, index) {
              if (row.Id.toLowerCase() === selectItem.toLowerCase()) {
                _this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            })
          })
        })
        _this.tableLoading = false
      }).catch(err => {
        _this.tableLoading = false
        return err
      })
    },
    indexMethod (index) {
      return index + 1
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getQuestionGroups()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getQuestionGroups()
    },
    nextPage () {
      this.currentPage = this.currentPage + 1
      this.listQuery.skipCount = (this.currentPage - 1) * this.listQuery.maxResultCount
      this.getQuestionGroups()
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
      this.elementItem.RandomQuestionGroups = []
      this.selectRows.forEach(element => {
        const groupItem = {}
        groupItem.Id = element.Id
        groupItem.Name = element.Name
        this.elementItem.RandomQuestionGroups.push(groupItem)
      })
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    openEditRandomQuestion: function (item, index, action, companyId) {
      this.dialogFormVisible = true
      this.currentPage = 1
      this.listQuery.companyId = companyId
      this.listQuery.skipCount = 0
      this.elementItem = item
      this.itemIndex = index
      this.action = action
      this.questionGroupList = []
      this.getQuestionGroups()
    },
    editElementRandomQuestion: function () {
      this.elementItem.RandomCondition.QuestionGroupIds = []
      this.selectRows.forEach(element => {
        this.elementItem.RandomCondition.QuestionGroupIds.push(element.Id)
      })
      this.fatherSubmitDialog(this.elementItem, this.itemIndex, this.action)
      this.dialogFormVisible = false
    },
    dialogClose: function (done) {
    },
    blurSingleNum (e) {
      const _this = this
      if (!e.target.value) {
        _this.elementItem.RandomCondition.Single.QuestionNum = 0
      }
    },
    blurMultipleNum (e) {
      const _this = this
      if (!e.target.value) {
        _this.elementItem.RandomCondition.Multiple.QuestionNum = 0
      }
    },
    blurTrueOrFalseNum (e) {
      const _this = this
      if (!e.target.value) {
        _this.elementItem.RandomCondition.TrueOrFalse.QuestionNum = 0
      }
    },
    blurBlankNum (e) {
      const _this = this
      if (!e.target.value) {
        _this.elementItem.RandomCondition.Blank.QuestionNum = 0
      }
    },
    blurQANum (e) {
      const _this = this
      if (!e.target.value) {
        _this.elementItem.RandomCondition.QA.QuestionNum = 0
      }
    }
  },
  created () {
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
